// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/IdentityRoleSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/IdentityRoleSortBy.proto.
 */
export const file_Enumerations_IdentityRoleSortBy: GenFile = /*@__PURE__*/
  fileDesc("CiVFbnVtZXJhdGlvbnMvSWRlbnRpdHlSb2xlU29ydEJ5LnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyp1ChJJZGVudGl0eVJvbGVTb3J0QnkSJQohSURFTlRJVFlfUk9MRV9TT1JUX0JZX1VOU1BFQ0lGSUVEEAASJgoaSURFTlRJVFlfUk9MRV9TT1JUX0JZX05BTUUQAxoGysfNDwEDIgQIARABIgQIAhACIgQIBBBjQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort Identity roles by.
 *
 * @generated from enum time_tracking.enumerations.IdentityRoleSortBy
 */
export enum IdentityRoleSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: IDENTITY_ROLE_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the roles by their name.
   *
   * @generated from enum value: IDENTITY_ROLE_SORT_BY_NAME = 3;
   */
  NAME = 3,
}

/**
 * Describes the enum time_tracking.enumerations.IdentityRoleSortBy.
 */
export const IdentityRoleSortBySchema: GenEnum<IdentityRoleSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_IdentityRoleSortBy, 0);

